import React, { Component } from "react";
import {
  message,
  Row,
  Col,
  Select,
  Alert,
  DatePicker,
  Tag,
  Typography,
} from "antd";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import {
  ModalItem,
  Form,
  FormItem,
  ErrorItem,
  ButtonItem,
  SelectItem,
  TextAreaItem,
} from "../../../../Components/Items";

const { Option } = Select;
const { Text } = Typography;

class ModalEditarDatosPortal extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    estadoPortalActual: 0,
    fechaActualDisplay: null,
    diasCredito: 0,
    fechaSugeridaDisplay: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.cargarDatos();
    }
  }

  cargarDatos() {
    const { venta } = this.props;

    if (!venta) return;

    const estadoInicial = venta.estadoPortal || 0;
    const diasCredito = venta.diasCredito || 0;

    const fechaBase = venta.fechaVencimiento
      ? moment(venta.fechaVencimiento)
      : moment(venta.fechaVenta);

    const fechaSugerida = moment(fechaBase).add(diasCredito, "days");

    this.setState({
      estadoPortalActual: estadoInicial,
      fechaActualDisplay: fechaBase,
      fechaSugeridaDisplay: fechaSugerida,
      diasCredito: diasCredito,
    });

    setTimeout(() => {
      if (this.formRef.current) {
        this.formRef.current.setFieldsValue({
          estadoPortal: estadoInicial,
          fechaVencimiento: fechaSugerida,
          observacionesPortal: venta.observacionesPortal || "",
        });
      }
    }, 100);
  }

  cerrarModal(exitoso = false) {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      loading: false,
      estadoPortalActual: 0,
      fechaActualDisplay: null,
      fechaSugeridaDisplay: null,
    });

    if (exitoso) {
      this.props.onSuccess();
    } else {
      this.props.onCancel();
    }
  }

  onFinish(values) {
    const { venta } = this.props;

    this.setState({ loading: true });

    const payload = {
      ventaId: venta._id,
      empresaId: this.props.empresaId,
      estadoPortal: values.estadoPortal,
      fechaVencimiento: values.fechaVencimiento,
      observacionesPortal: values.observacionesPortal,
    };

    axios
      .post("ventas/editarDatosPortal", payload, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Datos del portal actualizados");
          this.cerrarModal(true);
        } else {
          message.error("Error al actualizar datos");
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        console.error("Error:", err);
        message.error("Error de conexión");
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  handleValuesChange = (changedValues, allValues) => {
    if (changedValues.estadoPortal !== undefined) {
      this.setState({ estadoPortalActual: changedValues.estadoPortal });
    }
  };

  render() {
    const {
      estadoPortalActual,
      fechaActualDisplay,
      fechaSugeridaDisplay,
      diasCredito,
    } = this.state;

    const esSubido = estadoPortalActual === 2;

    return (
      <ModalItem
        title={`Editar Estado - ${this.props.venta?.numero || ""}`}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.cerrarModal()}
        width={500}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="form_editar_portal"
          layout="vertical"
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
          onValuesChange={this.handleValuesChange}
          bottom={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
              }}
            >
              <ButtonItem
                type="primary"
                onClick={() => this.cerrarModal()}
                rojo
                style={{ marginRight: 8 }}
              >
                Cancelar
              </ButtonItem>
              <ButtonItem type="primary" htmlType="submit">
                Guardar
              </ButtonItem>
            </div>
          }
        >
          <Row gutter={[16, 16]}>
            {/* 1. SELECCIÓN DE ESTADO */}
            <Col span={24}>
              <FormItem
                name="estadoPortal"
                label="Estado en Portal"
                rules={[{ required: true, message: "Selecciona un estado" }]}
              >
                <SelectItem placeholder="Seleccione estado">
                  <Option value={0}>Sin Subir</Option>
                  <Option value={1}>Pendiente / Revisando</Option>
                  <Option value={2}>Subido</Option>
                </SelectItem>
              </FormItem>
            </Col>

            {/* 2. ALERTA Y FECHAS */}
            <Col span={24}>
              {/* Alerta solo si NO es subido */}
              {!esSubido && (
                <Alert
                  message="Para habilitar la fecha de vencimiento, cambie el estado a 'Subido'."
                  type="info"
                  showIcon
                  style={{ marginBottom: 15, fontSize: "12px" }}
                />
              )}

              {/* Información de fechas */}
              {fechaActualDisplay && (
                <div
                  style={{
                    marginBottom: 10,
                    padding: "10px",
                    background: "#fafafa",
                    borderRadius: "6px",
                    border: "1px solid #f0f0f0",
                    opacity: esSubido ? 1 : 0.7
                  }}
                >
                  <div style={{ marginBottom: 5 }}>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Vencimiento Actual:
                    </Text>{" "}
                    <Tag color="green">
                      {fechaActualDisplay?.format("DD/MM/YYYY")}
                    </Tag>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Sugerida (+{diasCredito} días):
                    </Text>
                    <Tag color="blue">
                      {fechaSugeridaDisplay?.format("DD/MM/YYYY")}
                    </Tag>
                  </div>
                </div>
              )}

              {/* 3. DATE PICKER (Visible siempre, Deshabilitado según estado) */}
              <FormItem
                name="fechaVencimiento"
                label="Fecha de Vencimiento"
                rules={[
                  {
                    required: esSubido,
                    message: "Ingresa la fecha de vencimiento",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                  placeholder="Seleccione fecha"
                  disabled={!esSubido}
                />
              </FormItem>
            </Col>

            <Col span={24}>
              <FormItem
                name="observacionesPortal"
                label="Observaciones"
                pattern
                placeholder="Agregue una observaciones"
                max={100}
              >
                <TextAreaItem
                  placeholder="Observaciones para el portal"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalEditarDatosPortal);
